<h2 mat-dialog-title>Message</h2>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Schließen</button>
</div>
